export const lightTheme = {
	type: 'light',
	background: '#f5f5f5',
	text: {
		primary: '#000000',
		secondary: '#666666'
	},
	primary: '#007AFF',
	error: '#FF3B30',
	card: {
		background: '#ffffff',
		overlay: 'rgba(0,0,0,0.04)',
		imageBg: '#f5f5f5',
	},
	button: {
		background: '#007AFF',
		text: '#ffffff',
		hoverBackground: '#0056b3'
	},
	navigation: {
		background: '#ffffff',
		active: '#007AFF',
		inactive: '#999999'
	},
	border: 'rgba(0, 0, 0, 0.1)',
	weaponCard: {
		background: '#ffffff'
	},
	input: {
		background: '#ffffff',
		border: 'rgba(0, 0, 0, 0.1)',
		placeholder: '#999999',
		balancePanel: '#fff'
	},
	balancePanel: '#fff'
};

export const darkTheme = {
	type: 'dark',
	background: '#000000',
	text: {
		primary: '#ffffff',
		secondary: '#999999'
	},
	primary: '#007AFF',
	error: '#FF453A',
	card: {
		background: '#1C1C1E',
		overlay: 'rgba(255,255,255,0.05)',
		imageBg: '#181818',
	},
	button: {
		background: '#007AFF',
		text: '#ffffff',
		hoverBackground: '#0056b3'
	},
	navigation: {
		background: '#1C1C1E',
		active: '#007AFF',
		inactive: '#666666'
	},
	border: 'rgba(255, 255, 255, 0.1)',
	weaponCard: {
		background: '#1C1C1E'
	},
	input: {
		background: '#1C1C1E',
		border: 'rgba(255, 255, 255, 0.1)',
		placeholder: '#666666',
		balancePanel: '#1C1C1E'
	},
	balancePanel: '#1C1C1E'
}; 